<template>
  <div class="company-manage-app" v-loading="loading">
    <div class="title">应用列表</div>
    <div>
      <div class="right">
        <div class="mRight10">
          <el-input
            v-model="searchText"
            size="small"
            placeholder="应用名称"
            clearable
            prefix-icon="el-icon-search"
            @input="search"
          ></el-input>
        </div>
        <base-button type="primary" @click="templateVisible = true">
          新建
        </base-button>
        <dropdown-menu
          style="margin-left: 10px"
          v-if="appTableCmds.length > 0"
          :menu-list="appTableCmds"
          @click="handleCommand"
          placement="bottom-end"
        >
          <base-button icon="el-icon-more" style="padding: 6px 8px;"></base-button>
        </dropdown-menu>
      </div>
    </div>
    <div class="table-wrapper">
      <el-table
        ref="appsTable"
        :data="filterData"
        tooltip-effect="dark"
        height="100%"
        v-ps="'.el-table__body-wrapper'"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column
          v-for="appColumn in appColumns"
          :key="appColumn.value"
          :prop="appColumn.value"
          :label="appColumn.label"
          :width="appColumn.width"
        >
          <template slot-scope="scope">
            <template v-if="appColumn.value === 'name'">
              <div class="app-item">
                <div class="app-icon" :style="{ background: scope.row.color }">
                  <svg-icon
                    :icon-class="scope.row.icon ? 'app_' + scope.row.icon : 'app_icon-01'"
                  ></svg-icon>
                </div>
                <div class="font-main app-name">
                  {{ scope.row[appColumn.value] }}
                  <el-tag v-if="scope.row.shared" size="small" style="margin-left: 5px">
                    公开
                  </el-tag>
                </div>
              </div>
            </template>
            <template v-else>
              <div>{{ _.get(scope.row, appColumn.value) }}</div>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template v-slot="scope">
            <el-button @click.stop="toManageApp(scope.row)" type="text">
              编辑
            </el-button>
            <el-button @click.stop="copyApp(scope.row)" type="text">
              复制
            </el-button>
            <el-button @click.stop="exportApp(scope.row)" type="text">
              导出
            </el-button>
            <dropdown-menu
              :menu-list="[{ title: '删除', command: 'deleteApp' }]"
              @click="handleTableCommand($event, scope.row)"
              placement="bottom-end"
              style="margin-left: 10px;"
            >
              <span class="pointer">
                <i class="el-icon-more"></i>
              </span>
            </dropdown-menu>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <base-dialog :visible.sync="templateVisible" :show-close="true">
      <template v-slot:header>
        <div>新建应用</div>
      </template>
      <div class="template-wrap">
        <div class="template-card" @click="showAddApp">
          <span class="template-icon">
            <svg-icon icon-class="company_empty-template"></svg-icon>
          </span>
          <span class="option">空白模板</span>
        </div>
        <div class="template-card" @click="gotoAppTemplateCenter">
          <span class="template-icon">
            <svg-icon icon-class="company_template-center"></svg-icon>
          </span>
          <span class="option">模板中心</span>
        </div>
      </div>
    </base-dialog>
    <base-dialog :visible.sync="appVisible" :show-close="true" v-loading="addLoading">
      <template v-slot:header>
        <div>新建应用</div>
      </template>
      <el-form class="form" :model="curApp" label-width="88px" label-position="left">
        <el-form-item label="应用名称">
          <el-input v-model.trim="curApp.name"></el-input>
        </el-form-item>
        <el-form-item label="设计图标" class="design-icon">
          <span
            class="icon-info"
            :style="curApp.color ? 'background:' + curApp.color : 'background:' + appColors[0]"
          >
            <svg-icon
              style="color: #fff"
              :icon-class="curApp.icon ? 'app_' + curApp.icon : 'app_' + appIcons[0]"
            ></svg-icon>
          </span>
          <design-icon-popper
            style="margin: 4px 8px"
            :colors="appColors"
            :icons="appIcons"
            :cur-data="curApp"
            from="app"
            @changeData="changeAppInfo"
          ></design-icon-popper>
        </el-form-item>
      </el-form>
      <template v-slot:footer>
        <base-button @click="appVisible = false">取消</base-button>
        <base-button type="primary" @click="addApp">确定</base-button>
      </template>
    </base-dialog>
    <base-dialog show-close :visible.sync="deleteVisible">
      <template v-slot:header>删除应用</template>
      <div style="margin: 20px 0 10px 0; color:#606266">
        注意：应用下所有配置和数据将被永久删除，不可恢复
      </div>
      <div style="margin-bottom: 10px; color:#606266">
        请输入应用名称 "
        <span style="color: red">{{ app.name }}</span>
        "，表示您确认删除应用
      </div>
      <el-form :model="deleteInfo" status-icon :rules="rules" ref="deleteInfo" label-width="0">
        <el-form-item prop="appName">
          <el-input v-model="deleteInfo.appName"></el-input>
        </el-form-item>
      </el-form>
      <template v-slot:footer>
        <span class="dialog-footer">
          <base-button @click="deleteVisible = false">取消</base-button>
          <base-button type="primary" @click="deleteApp('deleteInfo')">确定</base-button>
        </span>
      </template>
    </base-dialog>
    <base-dialog show-close :visible.sync="importVisible">
      <template v-slot:header>导入应用</template>
      <div style="color: #606266; margin: 10px 0 0 10px;">
        将应用文件导入当前企业，生成新的应用
      </div>
      <el-upload
        ref="upload"
        class="upload"
        drag
        name="inFile"
        :file-list="fileList"
        :multiple="false"
        action="/api/sheet/importApp"
        :auto-upload="false"
        :on-success="importSuccess"
        :before-upload="beforeUpload"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          将.qd格式的应用文件拖到此处，或
          <em>点击上传</em>
        </div>
      </el-upload>
      <template v-slot:footer>
        <span class="dialog-footer">
          <base-button @click="importVisible = false">取消</base-button>
          <base-button type="primary" @click="importApp">确定</base-button>
        </span>
      </template>
    </base-dialog>
  </div>
</template>
<script>
import * as appApi from "@/api/userCenter/app"
import BaseButton from "@/components/UIComponents/Button"
import BaseDialog from "@/components/BaseComponents/Dialog"
import DropdownMenu from "@/components/UIComponents/DropdownMenu"
import DesignIconPopper from "@/components/BaseComponents/DesignIconPopper"
import TableController from "@/views/Backend/Admin/Layout/mixin/TableController"
import { appIcons, appColors, appColumns, appTableCmds } from "./static"
import { stringIncludes } from "@/utils/common"

export default {
  name: "companyManageApp",
  components: { BaseDialog, BaseButton, DropdownMenu, DesignIconPopper },
  computed: {
    userPermission() {
      return this.$store.getters.userPermission
    }
  },
  data() {
    let validateAppName = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入应用名称"))
      } else if (this.deleteInfo.appName !== this.app.name) {
        callback(new Error('请输入应用名称 "' + this.app.name + '"'))
      } else {
        callback()
      }
    }
    return {
      appIcons,
      appColors,
      appColumns,
      appTableCmds,
      pageInfo: {
        total: 1,
        currentPage: 1,
        pageSize: 1000
      },
      loading: false,
      addLoading: false,
      apps: [],
      appVisible: false,
      templateVisible: false,
      curApp: {
        name: "",
        color: "",
        icon: ""
      },
      searchText: "",
      filterData: [],
      deleteVisible: false,
      importVisible: false,
      deleteInfo: {
        appName: ""
      },
      app: {},
      rules: {
        appName: [{ validator: validateAppName, trigger: "blur" }]
      },
      selectedAppIds: [],
      selectedAppNames: "",
      fileList: []
    }
  },
  mixins: [TableController],
  created() {
    this.refresh()
    // $router.replace只会走一遍created，组件不会重新创建
    switch (this.$route.query?.dialogName) {
      case "addEmptyApp":
        this.$router.replace({
          name: "company-manage-app",
          params: {
            dialogName: "addEmptyApp"
          }
        })
        break
      case "add":
        this.$router.replace({
          name: "company-manage-app",
          params: {
            dialogName: "add"
          }
        })
        break
    }
    switch (this.$route.params?.dialogName) {
      case "addEmptyApp":
        this.showAddApp()
        break
      case "add":
        this.templateVisible = true
        break
    }
  },
  methods: {
    refresh: function() {
      this.loading = true
      appApi.getAppList("MANAGE").then(apps => {
        this.apps = apps
        this.filterData = this.apps
        this.loading = false
      })
    },
    toManageApp(app) {
      this.$router.push({ name: "admin-app-info", params: { appId: app.id } })
    },
    setPublicApp(row) {
      this.$confirm("将此应用设置为公共应用？一旦设置将无法恢复！", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          appApi.shareApp(row.id).then(() => {
            this.refresh()
            this.$message({
              type: "success",
              message: "设置成功"
            })
          })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "设置已取消"
          })
        })
    },
    showAddApp() {
      this.curApp = {
        name: "",
        color: appColors[0],
        icon: appIcons[0]
      }
      this.templateVisible = false
      this.appVisible = true
    },
    showEditApp(app) {
      this.curApp.id = app.id
      this.curApp.name = app.name
      this.curApp.color = app.color || appColors[0]
      this.curApp.icon = app.icon || appIcons[0]
      this.appVisible = true
    },
    addApp() {
      let reg = /[\\\\/?"!#]/
      if (reg.test(this.curApp.name)) {
        return this.$message.error('应用名称不能包含特殊字符 （\\ / ? " ! #）')
      }
      this.addLoading = true
      if (this.curApp.id) {
        appApi.updateApp(this.curApp).then(res => {
          this.addLoading = false
          this.appVisible = false
          this.$message.success("编辑成功")
          this.refresh()
        })
      } else {
        appApi.createApp(this.curApp).then(app => {
          this.addLoading = false
          this.appVisible = false
          this.$message.success("创建成功")
          this.$router.push({ name: "admin-app-info", params: { appId: app.id } })
        })
      }
    },
    clickColor(color) {
      this.$set(this.curApp, "color", color)
    },
    clickIcon(icon) {
      this.$set(this.curApp, "icon", icon)
    },
    search() {
      this.filterData = this.apps.filter(i => stringIncludes(i.name, this.searchText))
    },
    copyApp(app) {
      this.$message.info("正在复制" + app.name)
      appApi.copyApp(app.id).then(res => {
        if (res.data.code === 0) {
          if (res.data.msg === "工作流发布失败，请手动发布") {
            this.$message.warning("工作流发布失败，请手动发布")
          } else {
            this.$message.success("复制成功")
            this.refresh()
          }
        } else {
          this.$message.error("复制失败")
        }
      })
    },
    exportApp(app) {
      appApi.exportApp(app.id)
    },
    handleCommand(command) {
      switch (command) {
        case "import": {
          this.importVisible = true
          break
        }
        case "batchExport": {
          this.$message.info("正在批量导出: " + this.selectedAppNames)
          appApi.batchExportApp(this.selectedAppIds)
          break
        }
      }
    },
    handleTableCommand(command, app) {
      this.deleteInfo.appName = ""
      switch (command) {
        case "deleteApp":
          this.deleteVisible = true
          this.app = app
          break
      }
    },
    deleteApp(formName) {
      this.$refs[formName].validate(valid => {
        if (!valid) return
        appApi.deleteApp(this.app.id, false).then(() => {
          this.$message.success("删除成功")
          this.refresh()
        })
        this.deleteVisible = false
      })
    },
    importApp() {
      this.$refs.upload.submit()
    },
    gotoAppTemplateCenter() {
      this.templateVisible = false
      const { href } = this.$router.resolve({
        name: "app-template-center",
        query: { from: "company-manage-app" }
      })
      window.open(href, "_blank")
    },
    handleSelectionChange(val) {
      this.selectedAppNames = ""
      this.selectedAppIds = val.map(app => app.id)
      val.forEach(app => (this.selectedAppNames = this.selectedAppNames + app.name + " ; "))
    },
    importSuccess() {
      this.importVisible = false
      this.$message.warning("操作已提交，请稍后查看")
      this.$refs.upload.clearFiles()
    },
    changeAppInfo(key, val) {
      this.$set(this.curApp, key, val)
    },
    beforeUpload(file) {
      let fileKinds = ["application/zip"]
      if (!(fileKinds.includes(file.type) || file.name.endsWith(".qd"))) {
        this.$message.error("上传文件只能是 .qd 或 .zip 格式")
        return false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.company-manage-app {
  display: flex;
  flex-flow: column;
  overflow: hidden;
  height: calc(100vh - 52px);
  margin: -15px 0;
  .title {
    font-size: $font-size-title-first;
    padding: 15px 20px 10px 20px;
    border-bottom: 1px solid #e4e4e4;
  }
  .right {
    display: flex;
    float: right;
    margin: 20px 20px 0 20px;
    ::v-deep {
      .el-input-group__append {
        padding: 0 10px;
      }
    }
  }
  .table-wrapper {
    flex: 1;
    overflow: hidden;
    padding: 0 0 0 30px;
    box-sizing: border-box;
    .el-table {
      .app-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 73px;
        &:not(:last-child) {
          border-bottom: 1px solid #e4e4e4;
        }
        .app-icon {
          @include flex-center;
          flex-shrink: 0;
          box-sizing: border-box;
          width: 48px;
          height: 48px;
          background: #1989fa;
          border-radius: 12px;
          margin-right: 24px;
          font-size: 28px;
          color: #fff;
        }
        .app-name {
          flex: auto;
        }
      }
    }
  }
  ::v-deep {
    .el-table td {
      padding: 5px 0;
    }
    .el-table th.el-table-column--selection {
      > .cell {
        padding-left: unset;
        margin-left: 15px;
      }
    }
  }
}
.form {
  padding-top: 14px;
  .design-icon {
    .icon-info {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 48px;
      height: 48px;
      font-size: 30px;
      border-radius: 6px;
    }
    ::v-deep {
      .el-form-item__content {
        display: flex;
        flex-wrap: wrap;
      }
    }
  }
}
.template-wrap {
  display: flex;
  margin: 30px 18px;
  justify-content: space-between;
}
.template-card {
  display: flex;
  flex-flow: column;
  text-align: center;
  align-items: center;
  width: 228px;
  height: 150px;
  color: $color-font-title;
  font-weight: bold;
  border-radius: 6px;
  box-sizing: border-box;
  cursor: pointer;
  overflow: hidden;
  .template-icon {
    margin: -74px;
    font-size: 230px;
  }
  .option {
    color: white;
    margin: -14px;
    margin-left: 10px;
    width: 100%;
    text-align: left;
  }
  &:hover {
    background-color: #e5e5e5;
  }
}
.upload {
  text-align: center;
  margin: 20px 40px;
}
</style>
